export enum EBuyerIdsWithFCADescriptionInsideElevators {
  KCM = 'ee93da16-760f-4395-bbb9-4fe46ca54796',
}
